import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { Notify } from '@flexisaf/flexibull2';
import urls from 'utils/config';
import {
  sendEmailToApplicantsFailed,
  sendEmailToApplicantsSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

const isUuid = (value) =>
  typeof value === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value
  );

function* sendEmail({ payload: { data, cb } }) {
  const { candidateIds, message, subject, applicationId, stage, stageId, status } =
    data;
  const url = `${API_BASE_URL}/email/candidates`;

  const submissionData = {
    message,
    subject,
    applicationId,
  };

  const resolvedStageId = stageId || stage;
  if (isUuid(resolvedStageId)) {
    submissionData.stageId = resolvedStageId;
  }
  if (status) {
    submissionData.status = status;
  }

  if (candidateIds?.length > 0) {
    Object.assign(submissionData, {
      candidateIds,
    });
  }

  const response = yield request({
    method: 'post',
    data: submissionData,
    url,
  });
  if (response.success) {
    Notify('Email sent successfully', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    if (cb) cb();
    yield put(sendEmailToApplicantsSuccess());
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
    yield put(sendEmailToApplicantsFailed(response.message));
  }
}

export function* onEmailSend() {
  yield takeEvery(ApplicantsActionTypes.SEND_EMAIL_START, sendEmail);
}
